import { PopupMessageBox } from "../messageBox";
import { onOptionButtonDownRedirectHome } from "../functions/Functions_General";
import { CommonData } from "../datastructures/gamestate/gameData";

export class ClockDisplay {
  //display clock and  store  player login time
  private clock: PIXI.Text;
  private container: PIXI.Container;
  private activeTimeSec: number;
  // public activeTimeHour:number;
  private ClockTick: PIXI.ticker.Ticker;
  private ticker_D: number;
  private displayHourlyActivity: Function;
  private activeGameData: CommonData;
  constructor(
    parent: PIXI.Container,
    hourlyActivityMessageDisplay: Function,
    activeGameData: CommonData
  ) {
    this.container = new PIXI.Container();
    // parent.addChild(this.container);//not used anymore just hidden for the sake of not breaking working code
    parent;
    this.clock = new PIXI.Text(
      new Date().getHours() + ":" + new Date().getMinutes(),
      {
        fontFamily: "Tahoma, Helvetica, sans-serif",
        fontWeight: "bold",
        fontSize: 26,
        fill: "white",
        stroke: "#444444",
        strokeThickness: 3,
      }
    );
    this.clock.x = 90;
    this.clock.y = 3;
    this.clock.alpha = 0.7;
    this.activeTimeSec = 0;
    this.activeGameData = activeGameData;
    // this.activeTimeHour=0;
    this.displayHourlyActivity = hourlyActivityMessageDisplay;
    // console.log(this.displayHourlyActivity)
    this.container.addChild(this.clock);
    this.clock.tint = 0xaabbcc;
    this.updateTime();
    this.ticker_D = Date.now();
    this.ClockTick = new PIXI.ticker.Ticker();
    this.ClockTick.stop();
    this.ClockTick.add(() => {
      if (Date.now() - this.ticker_D > 10000) {
        //Check TimeCheckEvery10Sec
        // console.log("clockTick")
        this.ticker_D = Date.now();
        this.updateTime();
        this.activeTimeSec += 10; //in seconds
        if (this.activeTimeSec >= 3600) {
          // showMessage you have been playing for x amount of time
          activeGameData.playTimeHours += 1;
          this.activeTimeSec = 0;
          this.displayHourlyActivity(this.activeGameData);
        }
      }
    });
    this.container.y = 1080 - this.container.height - 10;
    // this.ClockTick.start();
    this.createBox();
    if (activeGameData.isMobile) {
      // this.clock.position.set(10, -25);
      this.clock.position.set(85, 10);
    }
  }
  //  actionEveryHour()
  // {
  //     this.displayHourlyActivity()
  // }
  public getClockText = (): PIXI.Text => {
    return this.clock;
  };
  public setPosition = (Position: { x: number; y: number }): void => {
    this.clock.x = Position.x;
    this.clock.y = Position.y;
  };
  public disableClock = (): void => {
    this.setMainClockVisible(false);
    this.ClockTick.stop();
  };
  private updateTime() {
    let minutes: string | number = new Date().getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    let hours: string | number = new Date().getHours();
    if (hours < 10) {
      hours = "0" + hours;
    }
    if (this.clock.text != hours + ":" + minutes) {
      this.clock.text = hours + ":" + minutes;
    }

    if (this.activeGameData.isMobile && this.activeGameData.playOnPortrait) {
      // setClockTime
      this.activeGameData.mobilePortraitUI.setClockTime(this.clock.text);
    }
  }

  private createBox() {
    this.activeGameData.playerActivityMessageBox = new PopupMessageBox(
      2,
      this.activeGameData.size,
      this.activeGameData
    );
    this.activeGameData.playerActivityMessageBox.setHeadText(
      this.activeGameData.gameTextGeneral.activeMessage
    );
    this.activeGameData.playerActivityMessageBox.setBodyText(
      this.activeGameData.playTimeHours +
        " " +
        this.activeGameData.gameTextGeneral.activeMessage2 +
        "!"
    );
    // this.activeGameData.playerActivityMessageBox.setChildOf(this.activeGameData.gameScene);
    this.activeGameData.playerActivityMessageBox.setLabel(
      0,
      this.activeGameData.gameTextGeneral.continue
    );
    this.activeGameData.playerActivityMessageBox.setLabel(
      1,
      this.activeGameData.gameTextGeneral.quitgame
    );
    this.activeGameData.playerActivityMessageBox.setButtons(
      0,
      this.closeMessageWindow.bind(this)
    );
    this.activeGameData.playerActivityMessageBox.setButtons(1, this.homeUrl);
    // this.activeGameData.playerActivityMessageBox.openMessageWindow(true);
    // this.activeGameData.playerActivityMessageBox.messageBoxContainer.alpha=1;
    this.activeGameData.playerActivityMessageBox.setMessageBoxPosY(380); //.messageBoxContainer.y = 380;

    // this.activeGameData.playerActivityMessageBox.setMessageBoxVisibile(true)
  }

  private homeUrl = (): void => {
    onOptionButtonDownRedirectHome();
  };
  private closeMessageWindow() {
    this.activeGameData.playerActivityMessageBox.setMessageBoxVisibile(false);
  }

  public start = (): void => {
    this.ClockTick.start();
  };
  public setColor = (newColor: number): void => {
    this.clock.tint = newColor;
  };
  public setMainClockVisible = (bool: boolean): void => {
    if (bool) {
      this.clock.alpha = 1;
    } else {
      this.clock.alpha = 0;
    }
  };
}
